module.exports = __webpack_public_path__ + "media/images/client-23-ab87c7f176be3ba8b59b4eea52748cc1.png";